export default __webpack_public_path__ + "static/Paritosh Keertikar-b2c3b5cab312bec6d668f9f01912e37c.webp";